<template>
  <Modal :showModal="showModal">
    <h3>{{ lang.user_groups_create }}</h3>
    <div class="form">
      <div>
        <label for="name">{{ lang.form.labels.name }}</label>
        <div class="input-container">
          <input
            type="text"
            id="name"
            name="name"
            v-model="form.name"
            :placeholder="lang.form.placeholders.name"
            ref="groupNameInput"
          />
        </div>
      </div>
      <div>
        <UsersSelect
          ref="userSelector"
          :label="lang.form.labels.users"
          :lang="lang"
        ></UsersSelect>
      </div>

      <div class="buttons">
        <button
          :disabled="creatingGroup"
          @click="createGroup"
          class="btn btn-primary"
        >
          {{ lang.actions.create }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import axios from "axios";
import UsersSelect from "./UsersSelect.vue";
import Modal from "./Modal.vue";
export default {
  components: { Modal, UsersSelect },
  props: {
    lang: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      availableCompanies: [],
      form: {
        name: "",
      },
      showModal: false,
      creatingGroup: false,
    };
  },
  mounted() {
    this.$eventBus.$on("openCreateModal", () => {
      this.showModal = true;
    });

    this.$eventBus.$on("hideModals", () => {
      this.showModal = false;
    });
  },
  methods: {
    createGroup() {
      if (this.form.name === "") {
        return;
      }
      this.creatingGroup = true;

      let selectedUsers = this.$refs.userSelector.selectedUsers;
      let userIds = [];
      selectedUsers.forEach((user) => [userIds.push(user.id)]);

      axios
        .post("/users/groups/create", {
          name: this.form.name,
          userIds: userIds,
        })
        .then((response) => {
          this.$emit("fetchData");
          this.showModal = false;
          this.creatingGroup = false;
          this.form.name = "";
        })
        .catch((err) => {
          this.showModal = false;
          this.creatingGroup = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  margin-bottom: 25px;
  line-height: 1.5rem;
  font-weight: 500;
  font-size: 1.5rem;
}
</style>